(() => {
  const key = 'nyvolt.recent-products.v1';
  const valid = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,180}$/.test(value);
  const load = () => {
    try {
      const value = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(value) ? [...new Set(value.filter(valid))].slice(0, 12) : [];
    } catch { return []; }
  };
  const record = document.querySelector('[data-nv-viewed-product]');
  if (record) {
    try {
      const handle = JSON.parse(record.textContent);
      if (valid(handle)) localStorage.setItem(key, JSON.stringify([handle, ...load().filter(item => item !== handle)].slice(0, 12)));
    } catch {}
  }
  if (customElements.get('nv-recently-viewed')) return;
  customElements.define('nv-recently-viewed', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      this.renderVersion = (this.renderVersion || 0) + 1;
      this.querySelector('[data-recent-clear]').addEventListener('click', () => {
        this.renderVersion += 1;
        try { localStorage.removeItem(key); } catch {}
        this.hidden = true;
        this.querySelector('[data-recent-track]').replaceChildren();
      }, { signal: this.events.signal });
      const handles = load().slice(0, 6);
      if (!handles.length) return;
      this.hidden = false;
      this.setAttribute('aria-busy', 'true');
      this.querySelector('[data-recent-track]').style.minHeight = '280px';
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) { this.observer.disconnect(); this.render(handles); }
        }, { rootMargin: '350px 0px' });
        this.observer.observe(this);
      } else this.render(handles);
    }
    async render(handles) {
      const version = this.renderVersion;
      const signal = this.events.signal;
      const base = this.dataset.root.replace(/\/$/, '');
      const cards = await Promise.all(handles.map(async handle => {
        try {
          const response = await fetch(`${base}/products/${encodeURIComponent(handle)}?section_id=nyvolt-recent-card`, { signal });
          if (!response.ok) return null;
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const card = doc.querySelector('.nv-mobility__product');
          return card ? document.importNode(card, true) : null;
        } catch { return null; }
      }));
      if (!this.isConnected || signal.aborted || this.renderVersion !== version) return;
      const track = this.querySelector('[data-recent-track]');
      track.replaceChildren(...cards.filter(Boolean));
      track.style.minHeight = '';
      this.removeAttribute('aria-busy');
      this.hidden = !track.childElementCount;
    }
    disconnectedCallback() {
      this.renderVersion += 1;
      this.events?.abort(); this.events = null; this.observer?.disconnect();
    }
  });
})();
